import { render } from "./kalio-startup-application-status-feedback.vue?vue&type=template&id=07d8e2a1"
import script from "./kalio-startup-application-status-feedback.vue?vue&type=script&lang=js"
export * from "./kalio-startup-application-status-feedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__